import AcceptStepActions from './AcceptStepActions.component';

export default AcceptStepActions;